




































































import { Vue, Component } from 'vue-property-decorator';
import UserAPI from '@/services/rest/bemob/user';

@Component({
  components: {
  }
})
export default class UploadConversions extends Vue {
  api: UserAPI = new UserAPI();

  conversion: string = '';
  fileUploading: boolean = false;
  conversionsUploading: boolean = false;

  uploadFile() {
    //@ts-ignore
    this.$refs.fileInput.click();
  }

  onFileChange($event: any) {
    const file = $event.target.files || $event.dataTransfer.files;
    if (file.length) {
      if (file[0].size > 2097152) {
        return this.bus.emit('toast-error', this.t('File is too big. Maximum file size is 2Mb'));
      }
        
      let reader: any = new FileReader();
      reader.onload = () => {
        this.fileUploading = true;
        this.api.postUploadConversions({ conversions: reader.result.replace(/\r/gmi, '') }).then(() => {
          this.bus.emit('toast-success', this.t('Conversions uploaded successfully.'));
          this.fileUploading = false;
        }).catch(()=>{
          this.bus.emit('toast-error', this.t('Could not upload conversions.'));
          this.fileUploading = false;
        })
      };
      reader.readAsText(file[0]);
    }
  }

  uploadConversions() {
    this.conversionsUploading = true;
    this.api.postUploadConversions({ conversions: this.conversion }).then(() => {
      this.bus.emit('toast-success', this.t('Conversions uploaded successfully.'));
      this.conversionsUploading = false;
      this.conversion = '';
    }).catch(()=>{
      this.bus.emit('toast-error', this.t('Could not upload conversions.'));
      this.conversionsUploading = false;
      this.conversion = '';
    })
  }
}
